<div askModalHeader class="modal-header">
  <h2 class="title">{{ 'DELETE_ANSWER_TEMPLATE' | translate }}</h2>
</div>

<div askModalBody class="modal-body">
  <p>{{ 'DELETE_ANSWER_TEMPLATE_CONFIRMATION' | translate }}</p>
</div>

<div askModalFooter class="modal-footer">
  <ask-button type="secondary" (onClick)="close(); logCancelClick();">{{ 'ACTIONS.CANCEL' | translate }}</ask-button>

  <ask-button
    type="primary"
    (onClick)="delete(); logDeleteClick();"
    [loading]="loading"
    [disabled]="loading"
  >
    {{ 'ACTIONS.DELETE' | translate }}
  </ask-button>
</div>

